/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GifCollectionResponse } from '../models/GifCollectionResponse';
import type { GifDetails } from '../models/GifDetails';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GiphyControllerService {
    /**
     * @returns GifCollectionResponse OK
     * @throws ApiError
     */
    public static trendingGiphy({
        limit = 10,
        offset,
    }: {
        limit?: number,
        offset?: number,
    }): CancelablePromise<GifCollectionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/of-chat/giphy/trending',
            query: {
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * @returns GifCollectionResponse OK
     * @throws ApiError
     */
    public static searchGiphy({
        query,
        limit = 10,
        offset,
    }: {
        query: string,
        limit?: number,
        offset?: number,
    }): CancelablePromise<GifCollectionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/of-chat/giphy/search',
            query: {
                'query': query,
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * @returns GifDetails OK
     * @throws ApiError
     */
    public static getGif({
        gifId,
    }: {
        gifId: string,
    }): CancelablePromise<GifDetails> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/of-chat/giphy/gifs/{gifId}',
            path: {
                'gifId': gifId,
            },
        });
    }
}
